import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ChartTemplatePreviewComponent} from '../chart-preview/chart-preview.component';
import {CommonModule} from '@angular/common';
import {
    DxAccordionModule,
    DxButtonModule, DxCheckBoxModule, DxColorBoxModule,
    DxDrawerModule,
    DxFileUploaderModule,
    DxFormModule, DxLoadIndicatorModule,
    DxPopupModule, DxSelectBoxModule, DxTagBoxModule,
    DxTemplateModule,
    DxTextBoxModule, DxTileViewModule, DxValidatorModule
} from 'devextreme-angular';
import {ChartTemplate, TenantOption} from '../../model/Theme';
import {SelectionModel} from "@angular/cdk/collections";
import {ChartTemplateService} from "../../services/chart-template-service";
import {ChartPropertiesService} from "../../services/chart-properties-service";
import _ from "lodash";
import {encode} from "base-64";
declare const highed: any;
import notify from "devextreme/ui/notify";
import * as Highcharts from 'highcharts';
import {ReportType} from "../../model/ReportType";
import {TenantService} from "../../services/tenant-service";

(window as any).Highcharts = Highcharts;

@Component({
    selector: 'chart-panel-component',
    imports: [
        CommonModule,
        DxFormModule,
        DxFileUploaderModule,
        DxPopupModule,
        DxButtonModule,
        DxAccordionModule,
        DxTemplateModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxColorBoxModule,
        DxLoadIndicatorModule,
        DxSelectBoxModule,
        DxDrawerModule,
        DxTileViewModule,
        DxCheckBoxModule,
        DxTagBoxModule,
        ChartTemplatePreviewComponent
    ],
    templateUrl: './chart-panel-component.html',
    styleUrl: './chart-panel-component.scss'
})
export class ChartPanelComponent implements OnInit {
    processing: boolean = false;
    @Input() visible!: boolean;
    @Input() template!: ChartTemplate;
    @Output() visibleChange = new EventEmitter<boolean>();

    @Output() onFinished = new EventEmitter<boolean>();

    _template: ChartTemplate = {} as ChartTemplate;
    tenants: TenantOption[] = [];
    reportTypesList: string[] = ["ALL", ...Object.values(ReportType)];
    detailsPanelExpanded: boolean = false;
    templateToRemove: ChartTemplate | null = null;

    ngOnInit() {
        this._template = this.template;
        this.tenantService.getTenantList()
            .subscribe(tenantList => {
                this.tenants = [{displayName: "ALL", value: "ALL"}, ...Object.values(tenantList)];
            });
    }

    onVisibleChange(newValue: boolean) {
        this.visible = newValue;
        this.visibleChange.emit(this.visible);
    }

    __allChartTemplates: ChartTemplate[] = [];
    chartTemplates: ChartTemplate[] = [];
    selectedTemplate: any;
    selection = new SelectionModel<ChartTemplate>(true);
    editor: any;

    @ViewChild("editorDiv")
    editorDiv!: ElementRef<HTMLElement>;

    private emptyProject: any;

    constructor(
        private chartTemplatesService: ChartTemplateService,
        private chartProperties: ChartPropertiesService,
        private tenantService: TenantService
    ) {}

    ngAfterViewInit(): void {
        this.loadChartsEditorAndTemplates(this.editorDiv.nativeElement);
    }

    searchText: string = '';

    filterCharts(e: any) {
        this.searchText = (e?.value || '').toLowerCase();
        this.applyFilter();
    }

    private applyFilter() {
        if (!this.searchText) {
            this.chartTemplates = this.__allChartTemplates;
        } else {
            this.chartTemplates = this.__allChartTemplates.filter(template => template.name && template.name.toLowerCase().includes(this.searchText));
        }
    }

    addChart() {
        const newChart = new ChartTemplate();
        newChart.name = "New Chart Template";
        newChart.tenant = [];
        const emptyProject = _.cloneDeep(this.emptyProject);
        this.chartProperties.loadDataToChart(emptyProject, this.getSampleData());
        newChart.jsonString = JSON.stringify(emptyProject);
        this.__allChartTemplates.push(newChart);
        this.selectChartTemplate(newChart);
    }

    deleteChart(selectedTemplate: ChartTemplate) {
        this.templateToRemove = selectedTemplate;
    }

    confirmDelete() {
        if (!this.templateToRemove) return;

        const selectedTemplate = this.templateToRemove;
        this.templateToRemove = null;
        const chartIndex = this.chartTemplates.indexOf(selectedTemplate);
        const allIndex = this.__allChartTemplates.indexOf(selectedTemplate);

        if (!selectedTemplate.id) {
            if (chartIndex > -1) {
                this.chartTemplates.splice(chartIndex, 1);
            }
            if (allIndex > -1) {
                this.__allChartTemplates.splice(allIndex, 1);
            }
            notify(`Template ${selectedTemplate.name} has been removed`, "success");
            this.selectFirstOrNothingIfEmpty();
            return;
        }

        this.chartTemplatesService.remove(selectedTemplate.id)
            .subscribe({
                next: () => {
                    if (chartIndex > -1) {
                        this.chartTemplates.splice(chartIndex, 1);
                    }
                    if (allIndex > -1) {
                        this.__allChartTemplates.splice(allIndex, 1);
                    }
                    notify(`Template ${selectedTemplate.name} has been removed`, "success");
                    this.selectFirstOrNothingIfEmpty();
                },
                error: (error) => {
                    console.error('Error deleting template:', error);
                }
            });
    }

    onTenantChange(e: any) {
        this.onListWithAllChange(e, "tenant");
    }

    onReportTypeChange(e: any) {
        this.onListWithAllChange(e, "reportType");
    }

    onListWithAllChange(e: any, propertyName: string) {
        if (!this.selectedTemplate) return;

        const newValue: string[] = e.value || [];
        const previousValue: string[] = e.previousValue || [];

        // if "ALL" was just added, keep only "ALL"
        if (newValue.includes("ALL") && !previousValue.includes("ALL")) {
            this.selectedTemplate[propertyName] = ["ALL"];
        }
        // if another option was added while "ALL" is selected, remove "ALL"
        else if (newValue.includes("ALL") && newValue.length > 1) {
            this.selectedTemplate[propertyName] = newValue.filter((t: string) => t !== "ALL");
        }
        else {
            this.selectedTemplate[propertyName] = newValue;
        }
    }

    selectFirstOrNothingIfEmpty() {
        if (this.chartTemplates && this.chartTemplates.length) {
            this.selectChartTemplate(this.chartTemplates[0]);
        } else {
            this.selectedTemplate = null;
        }
    }

    encode(s: string) {
        return encode(s);
    }

    selectChartTemplate(template: ChartTemplate) {
        if (!template || this.selectedTemplate === template) return;

        this.selectedTemplate = template;

        if (this.selectedTemplate) {
            if (!Array.isArray(this.selectedTemplate.tenant)) {
                this.selectedTemplate.tenant = this.selectedTemplate.tenant ? [this.selectedTemplate.tenant] : [];
            }
            if (!Array.isArray(this.selectedTemplate.reportType)) {
                this.selectedTemplate.reportType = this.selectedTemplate.reportType ? [this.selectedTemplate.reportType] : [];
            }
        }

        try {
            let templateProject;
            if (typeof template.jsonString === 'string') {
                templateProject = JSON.parse(template.jsonString);
            } else {
                templateProject = template.jsonString;
            }

            if (templateProject && this.editor && this.editor.chart) {
                this.fixTemplateColors(templateProject);
                
                // ensure series data exists and is properly formatted before loading to prevent customCode errors
                templateProject.options = templateProject.options || {};
                if (!templateProject.options.series || !Array.isArray(templateProject.options.series)) {
                    templateProject.options.series = this.getSampleData(this.chartProperties.isPie(templateProject));
                } else {
                    // ensure each series has data as an array
                    templateProject.options.series.forEach((s: any) => {
                        if (!s.data || !Array.isArray(s.data)) {
                            s.data = [];
                        }
                    });
                }
                
                this.editor.chart.loadProject(templateProject);
                
                setTimeout(() => this.editor.resize(), 0);
            }
        } catch (error) {
            console.error('Error loading template:', error);
        }
    }

    getActiveChartProject() {
        return this.editor.chart.toProject();
    }

    refreshSampleData() {
        const project = this.getActiveChartProject();
        const isPie = this.chartProperties.isPie(project);
        const data = this.getSampleData(isPie);
        this.chartProperties.loadDataToChart(project, data);
        this.editor.chart.loadProject(project);
    }

    saveChart(chart: ChartTemplate) {
        const projectForExport = this.getActiveChartProject();
        const data = this.getSampleData(this.chartProperties.isPie(projectForExport));
        this.chartProperties.loadDataToChart(projectForExport, data);

        chart.jsonString = JSON.stringify(projectForExport);
        const chartForSaving = _.cloneDeep(chart);
        chartForSaving.jsonString = this.encode(JSON.stringify(projectForExport));

        this.chartTemplatesService.save(chartForSaving)
            .subscribe((result: ChartTemplate) => {
                chart.id = result.id;
                chart.name = result.name;
                this.selectChartTemplate(chart);
                notify(`Template ${this.selectedTemplate?.name} has been saved`, "success");
            });
    }

    getSampleData(isPie?: boolean) {
        return !isPie ?
            [
                {
                    name: "Revenues",
                    data: [
                        { name: "Actual FY 2023", y: 865360 },
                        { name: "Actual FY 2024", y: 4015988 },
                        { name: "Budget FY 2025", y: 3040225 },
                        { name: "Estimated FY 2025", y: 3305829 },
                        { name: "Budget FY 2026", y: 2035600 }
                    ]
                },
                {
                    name: "Personnel Costs",
                    data: [
                        { name: "Actual FY 2023", y: 34320675 },
                        { name: "Actual FY 2024", y: 38911893 },
                        { name: "Budget FY 2025", y: 46860010 },
                        { name: "Estimated FY 2025", y: 47250963 },
                        { name: "Budget FY 2026", y: 54037802 }
                    ]
                },
                {
                    name: "Operating Costs",
                    data: [
                        { name: "Actual FY 2023", y: 6386135 },
                        { name: "Actual FY 2024", y: 7710807 },
                        { name: "Budget FY 2025", y: 10509480 },
                        { name: "Estimated FY 2025", y: 9510711 },
                        { name: "Budget FY 2026", y: 10049342 }
                    ]
                },
                {
                    name: "Capital Expense",
                    data: [
                        { name: "Actual FY 2023", y: 2886693 },
                        { name: "Actual FY 2024", y: 7104660 },
                        { name: "Budget FY 2025", y: 5907734 },
                        { name: "Estimated FY 2025", y: 3302871 },
                        { name: "Budget FY 2026", y: 4872863 }
                    ]
                }
            ]
            :
            [{
                name: "Actual",
                data: [
                    ["Charges for Services", 33],
                    ["Operating Grants", 1],
                    ["Capital Grants", 0.2],
                    ["Property Taxes", 44],
                    ["Other Taxes", 19],
                    ["Intergovernmental", 13],
                    ["Investment Income", 3],
                    ["Other Income", 9]
                ]
            }];
    }

    loadChartsEditorAndTemplates(element: any) {
        highed.ready(() => {
            this.editor = highed.Editor(element, {
                useHeader: false,
                features: "templates customize",
                customizer: {
                    noPreview: true,
                    liveUpdate: true
                },
                defaultChartOptions: {
                    exporting: {
                        enabled: false
                    }
                }
            });

            this.emptyProject = this.getActiveChartProject();

            this.chartTemplatesService.getAll()
                .subscribe(result  => {
                    this.parseTemplatesFromBackend(result ?? []);
                    this.selectFirstOrNothingIfEmpty();
                });
        });
    }

    importTemplate(event: any) {
        const file: File = event.target.files[0];

        if (file) {
            const formData = new FormData();
            formData.append("file", file);

            this.chartTemplatesService.upload(formData)
                .subscribe(res => {
                    let importedChart = new ChartTemplate();
                    importedChart.id = res.id;
                    importedChart.name = res.name;
                    importedChart.description = res.description;
                    importedChart.tenant = res.tenant;
                    importedChart.reportType = res.reportType;

                    if (typeof res.jsonString === 'string') {
                        importedChart.jsonString = res.jsonString;
                    } else {
                        importedChart.jsonString = JSON.stringify(res.jsonString || res);
                    }

                    this.__allChartTemplates.push(importedChart);
                    this.__allChartTemplates.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
                    this.chartTemplates = [...this.__allChartTemplates];
                    this.updateEditorProject(importedChart);
                    this.selectChartTemplate(importedChart);

                    this.saveChart(importedChart);
                    
                    this.reloadTemplates(importedChart.name);
                });

            event.target.value = null;
        }
    }

    private reloadTemplates(activeChartName: any) {
        this.chartTemplatesService.getAll()
            .subscribe(result => {
                this.parseTemplatesFromBackend(result ?? []);
                this.selectChartTemplate(this.chartTemplates.find(t => t.name === activeChartName) || this.chartTemplates[0]);
            });
    }

    private updateEditorProject(templateProject: ChartTemplate) {
        if (!this.editor || !this.editor.chart || !templateProject) return;
        this.fixTemplateColors(templateProject);
        this.editor.chart.loadProject(templateProject);

        setTimeout(() => this.editor.resize(), 0);
    }

    private fixTemplateColors(templateProject: any) {
        if (!templateProject) return;

        if (templateProject.options) {
            if (!templateProject.options.colors || templateProject.options.colors.length === 0) {
                delete templateProject.options.colors;
            }

            // remove null values that cause SVG attribute errors (e.g., borderRadius: null)
            this.chartProperties.removeNullValues(templateProject.options);
        }


        if (templateProject.template) {
            if (!templateProject.template.colors || templateProject.template.colors.length === 0) {
                delete templateProject.template.colors;
            }
        }
    }


    private parseTemplatesFromBackend(result: Object) {
        this.__allChartTemplates = [];
        this.chartTemplates = [];

        (result as ChartTemplate[])
            .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
            .forEach(template => {
                if (!Array.isArray(template.tenant)) {
                    template.tenant = template.tenant ? [template.tenant] : [];
                }
                this.__allChartTemplates.push(template);
                this.chartTemplates.push(template);
            });
    }

    protected copyTemplate(id: string) {
        if (id) {
            this.processing = true;
            this.chartTemplatesService.copy(id)
                .subscribe({
                    next: (result) => {
                        this.__allChartTemplates.push(result);
                        this.applyFilter();
                        this.selectChartTemplate(result);
                        notify(`Template ${result.name} has been copied`, "success");
                        this.processing = false;
                    },
                    error: (error) => {
                        console.error('Error copying template:', error);
                        notify("Failed to copy template.", "error");
                        this.processing = false;
                    }
                });
        } else {
            notify("Please select template to copy.", "info");
        }
    }
}
